<template src="./Financeiro.html"></template>

<script>
  import acordoControl from "@/services/acordo";
  import emailControl from "@/services/email";
  import devedores from "@/services/devedores";
  import juno from "@/services/juno";
  import { mapMutations } from "vuex";  

  function getPosition(string, subString, index) {
    return string.split(subString, index).join(subString).length;
  }
  export default {
    name: 'Endereco',
    data () {
      return {
        
        valid: true,
        acordo: {},
        dialogPagar: false,
        dialogConfirmation:false,
        dialogParcela: false,
        dialogEmail: false,
        editando: false,
        excluindo: {},
        cep: {},
        model: {},
        acordos: [],
        message: "",
        dialogError: false,
        menu: false,
        menu2: false,
        filtros: {status: [2], date: new Date().toISOString().substr(0, 7)},
        statusContratos: [
          {id: 2, nome: 'Aguardando Aprovação'},
          {id: 3, nome: 'Acordo Vigente'},
          {id: 4, nome: 'Acordo Vigente não pagos'},
          {id: 9, nome: 'Acordo Cancelado'}
        ],
        headersAcordo: [
          {
            text: 'Nome Operador',
            align: 'left',
            sortable: true,
            value: 'acordo.user.name'
          },
          {
            text: 'Nome Empresa',
            align: 'left',
            sortable: true,
            value: 'acordo.cliente.Nome',
            width: '20%'
          },
          {
            text: 'Nome Devedor',
            align: 'left',
            sortable: true,
            value: 'acordo.devedor.Nome'
          },
          {
            text: 'Valor Acordo',
            align: 'left',
            sortable: true,
            value: 'acordo.ValorAcordo'
          },
          {
            text: 'Tipo Acordo',
            align: 'left',
            sortable: true,
            value: 'acordo.proposta'
          },
          {
            text: 'Tipo Pagamento',
            align: 'left',
            sortable: true,
            value: 'acordo.tipoPagamento'
          },
          {
            text: 'Tipo Negociação',
            align: 'left',
            sortable: true,
            value: 'acordo.tipoNegociacao'
          },
          {
            text: 'Comentarios',
            align: 'left',
            sortable: true,
            value: 'acordo.detalhes'
          },
          {
            text: 'Status Acordo',
            align: 'left',
            sortable: true,
            value: 'acordo.StatusAcordo'
          },
          {
            text: 'Data Acordo',
            align: 'left',
            sortable: true,
            value: 'acordo.createdAt'
          },
          {
            text: 'Data Divida',
            align: 'left',
            sortable: true,
            value: 'acordo.DataDivida'
          },
          {
            text: 'Saldo Inicial',
            align: 'left',
            sortable: true,
            value: 'acordo.ValorDivida'
          }
        ],
        headersParcelas: [{
            text: 'Numero',
            value: 'numero'
          },
          {
            text: 'Vencimento',
            value: 'vencimento'
          },
          {
            text: 'Valor',
            value: 'valor'
          },
          {
            text: 'Valor Cliente',
            value: 'cliente'
          },
          {
            text: 'Valor Assoc',
            value: 'valorAssoc'
          },
          {
            text: 'Valor Juros',
            value: 'valorJuros'
          },
          {
            text: 'Valor Bruto',
            value: 'valorReceita'
          },
          {
            text: 'Ações',
            value: 'action'
          }
        ]
      }
    },
    async created () {
      this.setLoading(true);
      this.acordos = await acordoControl.getFinanc(this.filtros);
      this.setLoading(false);
    },
    methods: {
      async buscar() {
        this.setLoading(true);
        this.acordos = await acordoControl.getFinanc(this.filtros);
        this.setLoading(false);
      },
      async abrirAcordo (acordo) {
        this.acordo = acordo;
        this.dialogParcela = true;
      },
      getColorAcordo (acordo) {
        if (acordo && acordo.dtPagamento) return 'green';
      },
      async enviarEmail (item) {
        await emailControl.sendMessageParcela(item);
        this.dialogEmail = false;
        this.model = {};
      },
      async pagar(item) {
        this.dialogPagar = true;
        item.dtPagamento = new Date().toISOString().substr(0, 10);
        this.model = item;
      },
      async cancelar(item) {
        this.dialogConfirmation = true;
        this.model = item;
      },
      getDiasAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24);
          return result;
        }
        return null;
        
      },
      getMesesAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24/30);
          return result;
        }
        return null;
      },
      getAnosAtraso (data) {
        if (data) {
          let mes = data.substring(getPosition(data, '/', 1)+1,getPosition(data, '/', 2)+1);
          data = data.replace(mes, '');
          data = mes+data;
          let toDate = new Date(data);
          let result = new Date().getTime() - toDate.getTime();
          result = Math.trunc(result/1000/60/60/24/30/12);
          return result;
        }
        return null;
      },
      async pagarParcela (item) {
        try{
          this.setLoading(true);
          let response = await juno.pagarParcela(item);
          this.setLoading(false);
          this.dialogParcela = false;
          this.buscar();
          if (response.stPago == 'S') {
            this.message = "Parcela paga com sucesso! Deseja enviar Email?";
            this.dialogEmail = true;
          } else {
            this.message = "Parcela cancelada com sucesso!";
            this.dialogError = true;
            this.model = {};
          }
          
          this.dialogPagar = false;
          this.dialogConfirmation = false;
        } catch (e) {
          this.message = e.message;
          this.dialogError = true;
          this.model = {};
          this.dialogPagar = false;
          this.dialogConfirmation = false;
        }
      },
      buscaValorDesconto (parcelas) {
        if (parcelas&&parcelas.length>0) {
          let retorno = 0;
          for (const item of parcelas) {
            retorno += Number(item.cliente)+Number(item.valorAssoc?item.valorAssoc:0)+Number(item.valorJuros?item.valorJuros:0);
          }
          return retorno;
        } else {
          return 0;
        }
      },
      buscaValorCliente (parcelas) {
        if (parcelas&&parcelas.length>0) {
          let retorno = 0;
          for (const item of parcelas) {
            retorno += Number(item.cliente);
          }
          return retorno;
        } else {
          return 0;
        }
      },
      
      getStatusAcordo (status) {
        if (status == 1) {
          return 'Processo Cobrança';
        } else if (status == 2) {
          return 'Aguardando Aprovação';
        } else if (status == 3) {
          return 'Acordo Vigente';
        } else if (status == 4) {
          return 'Acordo em Atraso';
        } else if (status == 9) {
          return 'Acordo Cancelado';
        } else if (status == 6) {
          return 'Acordo Liquidado';
        }
      },
      getProposta (proposta) {
        if (proposta == 1) {
          return 'Fixa';
        } else if (proposta == 2) {
          return 'Exceção';
        } else if (proposta == 3) {
          return 'Gerado Devedor';
        }
      },
      getPagamento (pagamento) {
        if (pagamento == 1) {
          return 'Boleto';
        } else if (pagamento == 2) {
          return 'Deposito';
        } else if (pagamento == 3) {
          return 'Escritório';
        } else if (pagamento == 4) {
          return 'Na Loja';
        } else if (pagamento == 5) {
          return 'Pix';
        }
      },
      getNegociacao (pagamento) {
        if (pagamento == 1) {
          return 'Acordo Novo';
        } else if (pagamento == 2) {
          return 'Reativação';
        } else if (pagamento == 3) {
          return 'Renegociação';
        }
      },
      async saveAcordo (acor) {
        await acordoControl.save(acor);
        await this.buscar();
        this.dialogParcela = false;
        this.message = "Acordo salvo com sucesso!";
        this.dialogError = true;
      },
      async confirmItem (acor) {
        acor.StatusAcordo = '3';
        await acordoControl.save(acor);
        await this.buscar();
        this.dialogParcela = false;
        this.message = "Acordo aprovado com sucesso!";
        this.dialogError = true;
      },
      async recuseItem (acor) {
        acor.StatusAcordo = '9';
        await acordoControl.save(acor);
        await this.buscar();
        this.dialogParcela = false;
        this.message = "Acordo recusado com sucesso!";
        this.dialogError = true;
      },
      ...mapMutations({
        setLoading: "setLoading",
        setDevedor: "setDevedor",
      })
    }
  }
</script>


// WEBPACK FOOTER //
// src/pages/financeiro/Financeiro.vue